{
  "id": "001-005",
  "title": "Shuffling it up",
  "version": 0,
  "layout": {
    "tiles": {
      "0": {
        "1": {
          "id": "a1a47835",
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#0000ff",
                  "direction": 0
                },
                {
                  "color": "#ff0000",
                  "direction": 2,
                  "toggled": true
                }
              ],
              "id": "bbb6524d"
            }
          ]
        },
        "-1": {
          "id": "d04577a8",
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#0000ff",
                  "direction": 5,
                  "toggled": true
                },
                {
                  "color": "#ff0000",
                  "direction": 3
                }
              ],
              "id": "b51d512f"
            }
          ]
        }
      },
      "1": {
        "0": {
          "id": "2b3fd31d",
          "type": "tile",
          "items": [
            {
              "type": "reflector",
              "rotation": 2,
              "id": "d5820ff1"
            }
          ]
        },
        "-1": {
          "id": "15777e85",
          "type": "tile",
          "items": [
            {
              "type": "reflector",
              "id": "1c80477c"
            }
          ]
        }
      },
      "-1": {
        "0": {
          "id": "f272960c",
          "type": "tile",
          "items": [
            {
              "type": "reflector",
              "id": "8506728c"
            }
          ]
        },
        "-1": {
          "id": "671c53b3",
          "type": "tile",
          "items": [
            {
              "type": "reflector",
              "id": "c8c7367b",
              "rotation": 2
            }
          ],
          "modifiers": [
            {
              "type": "swap",
              "id": "842a76e2"
            }
          ]
        }
      }
    }
  },
  "requirements": [
    {
      "type": "connections",
      "amount": 2
    }
  ]
}
